import { p as proxyCustomElement, H, h, a as Host } from './index.js';
import { d as defineCustomElement$1 } from './p-B4Sv5V7D.js';

const tooltipCss = ":host{display:inline-flex;line-height:0;position:relative;width:-webkit-fit-content;width:fit-content}.inner{display:inline-flex}.inner,.wrapper{height:100%;width:100%}";

const _groups = {};
const WuiTooltip = /*@__PURE__*/ proxyCustomElement(class WuiTooltip extends H {
    constructor(registerHost) {
        super();
        if (registerHost !== false) {
            this.__registerHost();
        }
        this.__attachShadow();
        /**
         * Where to place relative to target element
         */
        this.placement = 'top';
        /**
         * When to trigger the tooltip
         *
         * Defaults to focus/hover.
         *
         * Can be set to 'none' to take manual control of opening/closing the tooltip.
         */
        this.trigger = 'focus';
        this.fixed = false;
        /**
         * Manually open/close tooltip.
         *
         * Only works when `trigger` is set to 'none'.
         */
        this.open = false;
        /**
         * When trigger is set to `'focus'`, determines how long until tooltip opens
         */
        this.timeoutOpen = 200;
        /**
         * When trigger is set to '`click`', determines how long until tooltip closes
         */
        this.timeoutClose = 1000;
        this.handleClick = () => {
            if (this.disabled) {
                return;
            }
            if (this.trigger !== 'click') {
                return;
            }
            this.setOpen(!this.open);
            if (this.timeoutClose && this.timeoutClose > 0 && this.timeoutClose !== Number.POSITIVE_INFINITY) {
                this._timeoutClose = setTimeout(() => {
                    this.setOpen(false);
                }, this.timeoutClose);
            }
        };
        this.handleFocus = () => {
            if (this.disabled) {
                return;
            }
            if (this.trigger !== 'focus') {
                return;
            }
            this.triggerOpen();
        };
        this.handleBlur = () => {
            if (this.disabled) {
                return;
            }
            if (this.trigger !== 'focus') {
                return;
            }
            this.setOpen(false);
        };
    }
    onChangeOpen(newValue) {
        // Ignore this prop change when not under manual control
        if (this.trigger !== 'none') {
            return;
        }
        this.setOpen(!!newValue);
    }
    componentWillLoad() {
        if (this.trigger === 'none') {
            this.open = !!this.open;
        }
    }
    getGroup() {
        if (!this.groupName) {
            return;
        }
        if (!_groups[this.groupName]) {
            _groups[this.groupName] = {
                open: false,
                timeout: undefined,
            };
        }
        return _groups[this.groupName];
    }
    setOpen(open) {
        // Clear any existing timeouts that would have otherwise opened/closed the tooltip
        this._timeoutOpen && window.clearTimeout(this._timeoutOpen);
        this._timeoutClose && window.clearTimeout(this._timeoutClose);
        this.open = open;
        const group = this.getGroup();
        if (group) {
            // Clear timeout that otherwise would have marked the group as being closed
            group.timeout && clearTimeout(group.timeout);
            if (open) {
                // Set group to open
                group.open = true;
            }
            else {
                // Wait a little bit before marking the group as closed
                group.timeout = setTimeout(() => {
                    group.open = false;
                }, 1000);
            }
        }
    }
    triggerOpen() {
        // If part of a group that's already open
        const group = this.getGroup();
        // Clear an existing timeout
        this._timeoutOpen && window.clearTimeout(this._timeoutOpen);
        this._timeoutOpen = setTimeout(() => {
            this.setOpen(true);
        }, 
        // Skip timeout if group is already open
        group?.open ? 0 : this.timeoutOpen);
    }
    render() {
        return (h(Host, { key: '1b860818adc3105517dbe75bfa8728dfbd6632da', "aria-label": this.label }, h("div", { key: 'd8f900e26ab7ef14b39a5f72cb0acc761b8457fb', class: "wrapper" }, h("wui-tooltip-label", { key: 'e47f191c3f1676ab85f86eba623a6ce1b8007e0c', open: this.open, label: this.label, placement: this.placement, fixed: this.fixed }), h("div", { key: 'a2c3d968573aa901458394c09f7ad4a546466d5a', tabIndex: -1, onClick: this.handleClick, onFocus: this.handleFocus, onBlur: this.handleBlur, onMouseEnter: this.handleFocus, onMouseLeave: this.handleBlur, class: "inner" }, h("slot", { key: '5278ad23e1b5837711f11def2cf7d973e16d77d4' })))));
    }
    static get watchers() { return {
        "open": ["onChangeOpen"]
    }; }
    static get style() { return tooltipCss; }
}, [257, "wui-tooltip", {
        "label": [1],
        "placement": [1],
        "trigger": [1],
        "fixed": [4],
        "open": [1540],
        "timeoutOpen": [2, "timeout-open"],
        "timeoutClose": [2, "timeout-close"],
        "groupName": [1, "group-name"],
        "disabled": [516]
    }, undefined, {
        "open": ["onChangeOpen"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiTooltip);
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { WuiTooltip as W, defineCustomElement as d };
